document.querySelectorAll<HTMLElement>('.testimonial-slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.testimonial-slider__wrapper');

	if (null !== wrapper) {
		new (window as Window).Swiper(wrapper, {
			slidesPerView: 1,
			watchOverflow: true,
			navigation: {
				nextEl: slider.querySelector('.testimonial-pagination__button--next'),
				prevEl: slider.querySelector('.testimonial-pagination__button--prev'),
			},
			on: {
				lock() {
					slider.classList.add('testimonial-slider--locked');
				},
				unlock() {
					slider.classList.remove('testimonial-slider--locked');
				},
			},
		});
	}
});
